module.exports = __webpack_public_path__ + "img/shipping.50265c95.svg";